import { BsTelegram } from "react-icons/bs";

const PresaleOverview = ({ tokenDetails }) => {
    return (
        <div className="component-container rounded-lg shadow-lg p-6 flex flex-col h-full">
            <span className="size-2 font-semibold">Presale Manager</span>
            <span className="text-center mt-4">
                {tokenDetails.weiRaised} BNB / {tokenDetails.hardCap} BNB
            </span>
            <span className="relative h-3 text-left">
                <span className="absolute w-full h-full presale-progress-panel" />
                <span
                    className="absolute h-full presale-progress-bar rounded-full bg-[#B961FF]"
                    style={{
                        width: `${
                            (tokenDetails.weiRaised / tokenDetails.hardCap) *
                            100
                        }%`,
                    }}
                ></span>
            </span>
            <span className="flex justify-between font-medium mb-4">
                <span className="size-sm">0.1 BNB</span>
                <span className="size-sm">2 BNB</span>
            </span>

            {tokenDetails.tokenArray.map((el, i) => (
                <div key={i} className="flex justify-between items-center py-1">
                    <span>{el.name}</span>
                    <span>{el.text}</span>
                </div>
            ))}

            <div className="flex  justify-between py-2 items-center">
                <div className="flex flex-col">
                    <span>Need Support?</span>
                    <span className="size-xs">
                        If you still cannot finalize then after receiving
                        support please cancel your sale and test your contract
                        thoroughly on our supported test nets!
                    </span>
                </div>
                <div>
                    <a
                        href="https://t.me/TitanDevSupport"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <BsTelegram
                            className="duration-150 fill-kadGrSt hover:fill-kadGr2Ed"
                            size={24}
                        />
                    </a>
                </div>
            </div>
        </div>
    );
};
export default PresaleOverview;
